/**
 * In-memory cache of the last LeadSearch (Prospects) search state.
 *
 * Preserves filter inputs, results, pagination tokens, job title tags and
 * selection across in-app navigation (e.g. LeadSearch → Contacts → LeadSearch).
 *
 * The cache lives for the lifetime of the app tab. It is intentionally NOT
 * persisted to localStorage so it doesn't survive full reloads/logouts and
 * doesn't leak across workspace switches – "return to your last view" is only
 * meaningful within the same session.
 *
 * Cleared explicitly via `resetProspectsSearchCache()` (e.g. from Clear Filters).
 */
export interface IProspectsSearchFields {
  state: string;
  city: string;
  countryCode: string;
  jobTitle: string[];
  school: string;
  companyName: string;
  companyDomain: string;
  companyLinkedinUrl: string;
  companyLinkedinId: string;
  companyState: string;
  companyCity: string;
  companyCountryCode: string;
  companyIndustry: string;
  companySize: string;
  companyFounded: string;
  companyMinFounded: string;
  companyMaxFounded: string;
  nextPageToken: string;
}

export interface IProspectsSearchCache {
  fields: IProspectsSearchFields;
  jobTitleInputValue: string;
  jobTitleOperators: ('and' | 'or')[];
  profiles: any[];
  profilesCount: number;
  nextPageToken: string;
  currentPageToken: string;
  visibleCount: number;
  lastPayload: any;
  selectedProfiles: any[];
  isAllSelected: boolean;
}

let cache: IProspectsSearchCache | null = null;

export const getProspectsSearchCache = (): IProspectsSearchCache | null => cache;

export const setProspectsSearchCache = (next: IProspectsSearchCache): void => {
  cache = next;
};

export const resetProspectsSearchCache = (): void => {
  cache = null;
};
